import type { FaireProductEntity } from "../../entity_types/product";

export const p_rx6sthfyk3: FaireProductEntity = {
  token: "p_rx6sthfyk3",
  type: "product",
  name: "Cozy Baseball Pattern Hooded Sweater with Pocket",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/5f36a4ca7c16d17c34b69da30cfb90eae4cb60ac0e76d4fa99e4d409a22ff572.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2987f884bd1d41b6ab80e97dac7bc35cfb23153d4bcc4adc4a2faa2daa78582.jpeg",
    "https://cdn.faire.com/fastly/a988df0e03a4f37b06639131bcc0d756b30796f3346865711bf3d797555d3907.jpeg",
    "https://cdn.faire.com/fastly/5e6ff8026756e53c66d1ffa0c1270f6570d127053a2256dc85476f71d6ac51f7.jpeg",
    "https://cdn.faire.com/fastly/211717f6d8f639d7a44205ec3e9d5f629585facc2029e87c0b7edd5bceebb013.jpeg",
  ],
  priceDollars: 26.4,
  description:
    "Size : One Size\r\nMaterial : 100% Poly.Microfiber\r\nAdd sporty flair to your casual looks with this cozy hooded pullover featuring an allover baseball stitch design. Soft, textured fabric, relaxed fit, and a kangaroo pocket make it a perfect choice for lounging, layering, or showing off team spirit in everyday comfort.\n",
  tags: [],
  msrpDollars: 52.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:26.502Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
